export default "__VITE_ASSET__397b7a1d__"